import dayjs from 'dayjs'

/** Human-readable file size, e.g. 1536 → "1.5 KB". */
export const formatFileSize = (bytes: number | null | undefined): string => {
    if (bytes === null || bytes === undefined) return ''
    if (bytes < 1024) return `${bytes} B`
    const units = ['KB', 'MB', 'GB', 'TB']
    let size = bytes / 1024
    let unitIndex = 0
    while (size >= 1024 && unitIndex < units.length - 1) {
        size /= 1024
        unitIndex += 1
    }
    return `${size.toFixed(1)} ${units[unitIndex]}`
}

/** Format an ISO timestamp for display, e.g. "18/06/2026 10:30". */
export const formatRequestedAt = (iso: string): string => dayjs(iso).format('DD/MM/YYYY HH:mm')
